// AI Workspace design tokens + the `.ai-ws` scope root (WEB-8000).
// Every `--ws-*` / `--pr-*` var a workspace surface relies on is defined here;
// feature style fragments assume this is composed BEFORE them (the @import
// must stay first in the final stylesheet for fonts to load).
//
// The vars are ALSO defined on `[data-ai-tokens]` (WEB-8001): Radix portals
// (sheets, dropdowns, tooltips) mount on ShadcnScope's shadow-root container,
// which is OUTSIDE `.ai-ws` — without this the vars collapse there. The
// zero-specificity `:where()` keeps every existing override winning exactly
// as before. Layout/typography stays on `.ai-ws` only.
const workspaceTokens = `
@import url('https://fonts.googleapis.com/css2?family=Newsreader:ital,opsz,wght@0,6..72,400;0,6..72,500;0,6..72,600;0,6..72,700;1,6..72,400&family=Inter:wght@400;450;500;600;700&family=Roboto+Mono:wght@400;500&display=swap');

:where(.ai-ws, [data-ai-tokens]) {
  --ws-bg: #ffffff;
  --pr-surface: #ffffff;
  --pr-ink: #2f3947;
  --pr-ink-3: #6b7c93;
  --pr-ink-4: #6b7c93;
  --pr-ink-5: #9baabe;
  --pr-accent-ink: #3e4957;
  --pr-accent-soft: rgba(29,61,72,0.06);
  --pr-accent-soft-2: rgba(29,61,72,0.12);
  --pr-r-sm: 6px;
  --ws-panel: #FFFFFF;
  --ws-soft: #edf1f5;
  --ws-hover: #e9eef3;
  --ws-sidebar: #edf1f5;
  --ws-ink: #2f3947;
  --ws-ink-2: #3e4957;
  --ws-ink-3: #4b5562;
  --ws-ink-4: #6b7c93;
  --ws-ink-5: #9baabe;
  --ws-line: #e4eaf0;
  --ws-line-2: #d3dae4;
  --ws-accent: #1d3d48;

  --ws-a-alex: #C47A4A;
  --ws-a-prospecting: #5F7F6A;
  --ws-a-forecasting: #4A6B85;
  --ws-a-postmeeting: #8B5A8F;
  --ws-a-human: #B8935A;

  --ws-ok: #2F7A4E;
  --ws-warn: #B8702A;
  --ws-err: #B84A3E;
  --ws-info: #3B6BA8;

  --ws-serif: 'Newsreader', 'Iowan Old Style', Georgia, serif;
  --ws-sans: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  --ws-mono: 'Roboto Mono', ui-monospace, Menlo, monospace;

  --ws-r-sm: 6px;
  --ws-r-md: 10px;
  --ws-r-lg: 14px;

  --ws-shadow-sm: 0 1px 2px rgba(15,30,45,0.04);
  --ws-shadow-md: 0 4px 16px rgba(15,30,45,0.06), 0 1px 2px rgba(15,30,45,0.04);
  --ws-shadow-lg: 0 24px 48px -12px rgba(15,30,45,0.14), 0 2px 6px rgba(15,30,45,0.04);
}

.ai-ws {
  display: grid;
  grid-template-columns: 248px 1fr;
  height: 100%;
  width: 100%;
  background: var(--ws-bg);
  color: var(--ws-ink-3);
  font-family: var(--ws-sans);
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
  -webkit-font-smoothing: antialiased;
  overflow: hidden;
  isolation: isolate;
}
`;

export default workspaceTokens;
